import {
    type CSSProperties,
    useMemo,
} from 'react'
import {DateTimeService} from 'swayok-react-mdb-ui-kit/services/DateTimeService'
import type {RegionCode} from '../types'

interface ScheduledEventLogoConfig {
    disabled?: boolean
    regions?: RegionCode[]
    startDate: Date
    endDate: Date
    logoUrl: string
    logoWrapperStyle?: CSSProperties
    logoStyle?: CSSProperties
    logoLabelStyle?: CSSProperties
}

const scheduledEvents: ScheduledEventLogoConfig[] = [
    {
        regions: ['vn', 'demo'],
        // Вьетнам: Ежегодный женский день 20 Октября.
        startDate: new Date(new Date().getFullYear() + '-10-08 00:00:00'),
        endDate: new Date(new Date().getFullYear() + '-10-20 23:59:59'),
        logoUrl: '/img/event-logo/dotoku-event-vn-women-day.svg',
        logoWrapperStyle: {
            height: 32,
        },
        logoStyle: {
            height: 63,
            transform: 'translateY(-15px)',
            // marginRight: -210, // Для сопоставления с основным логотипом.
        },
    },
    {
        // Halloween, глобальное мероприятие.
        startDate: new Date(new Date().getFullYear() + '-10-21 00:00:00'),
        endDate: new Date(new Date().getFullYear() + '-11-01 00:00:00'),
        logoUrl: '/img/event-logo/dotoku-event-halloween.svg',
        logoWrapperStyle: {
            height: 32,
        },
        logoStyle: {
            height: 56,
            transform: 'translateY(-15px)',
            // marginRight: -210, // Для сопоставления с основным логотипом.
        },
    },
]

const testEvent: ScheduledEventLogoConfig | null = null

// Возвращает конфигурацию логотипа события, если сейчас его период.
export function useScheduledEventLogoConfig(regionCode: RegionCode): ScheduledEventLogoConfig | undefined {
    return testEvent ?? useMemo(
        () => scheduledEvents.find(
            event => (
                !event.disabled
                // Фильтруем по региону.
                && (!event.regions || event.regions.includes(regionCode))
                // Фильтруем по периоду активности.
                && DateTimeService.now().isAfter(event.startDate)
                && DateTimeService.now().isBefore(event.endDate)
            )
        ),
        []
    )
}
